import Const from 'const';
import Action from 'actions';

const RelaxBuildRules = {
    setRelaxBuildRules(value) {
        return (dispatch) => {
            return dispatch({
                type: Const.SET_RELAX_BUILD_RULES,
                value,
            });
        };
    },
};

export default {...Action, ...RelaxBuildRules};
